export default __webpack_public_path__ + "static/media/reviews_bg.68621168.jpeg";